<template>
<div class="content">
	<div class="menu-bar">
		<div class="container">
			<Menubar></Menubar>
		</div>
	</div>
	<div class="main-banner">
		<div class="container">
			<p class="title " v-html="l10.All_Main_Body_Title1">

			</p>
			<p class="subtitle " v-html="l10.All_Main_Body_Title1_Description1">

			</p>

			<div class="download ">
				<template v-if="this.$store.state.lang != 'cn' || this.$store.state.cnDownloadUrl == this.$store.state.cnStaticDownloadUrl">
					<div class="store-btn"><a :href="appStoreUrl" target="_blank"><img id="appstore" src="../../assets/home/img-appstore.svg" class='pc_appstore_btn'></a></div>
				</template>
				<template v-else>
				</template>
				<template v-if="this.$store.state.lang == 'cn' && this.$store.state.cnDownloadUrl != ''">
					<div class="store-btn" @click="handleClickAndroidDownload"><img src="../../assets/home/img-android-download-btn.svg"></div>
				</template>
				<template v-else>
					<div class="store-btn"><a :href="googlePlayUrl" target="_blank"><img src="../../assets/home/img-googleplay.svg" class='pc_playstore_btn'></a></div>
				</template>
			</div>
			<div class="animation" v-if="this.$store.state.lang != 'cn'">
				<img src="../../assets/home/todomath_main_top_ani.png" />
			</div>

		</div>
	</div>
	<div id="article1" class="article">
		<div class="container">

			<p class="title " v-html="l10.All_Main_Body_Title2">

			</p>
			<p class="subtitle " v-html="l10.All_Main_Body_Title2_Description1">

			</p>
			<div class="articles ">
				<div>
					<img src="../../assets/home/img-main-testimonial-1.svg" />
					<p class="description" v-html="l10.All_Main_Body_Title2_Quote1">
					</p>
					<p class="source" v-html="l10.All_Main_Body_Title2_Source1">
					</p>
				</div>
				<div>
					<img src="../../assets/home/img-main-testimonial-2.png" />
					<p class="description" v-html="l10.All_Main_Body_Title2_Quote2">
					</p>
					<p class="source" v-html="l10.All_Main_Body_Title2_Source2">
					</p>
				</div>
				<div>
					<img src="../../assets/home/img-main-testimonial-3.svg" />
					<p class="description" v-html="l10.All_Main_Body_Title2_Quote3">
					</p>
					<p class="source" v-html="l10.All_Main_Body_Title2_Source3">
					</p>
				</div>

			</div>
			<div id="download600Img" class=" ">
				<!-- <img  src="../../assets/home/img-main-600-download.png" srcset="../../assets/home/img-main-600-download@2x.png 2x,../../assets/home/img-main-600-download@3x.png 3x"> -->
			</div>
		</div>
	</div>
	<div id="article2">
		<div class="container">
			<p v-html="l10.All_Main_Body_Title3">

			</p>
			<div class="descriptions">
				<div class="description">
					<p class="title" v-html="l10.All_Main_Body_Title3_Subtitle1">

					</p>
					<div class="text">

						<p v-html="l10.All_Main_Body_Title3_Subtitle1_Description1">

						</p>

						<p v-html="l10.All_Main_Body_Title3_Subtitle1_Description2">

						</p>

						<p v-html="l10.All_Main_Body_Title3_Subtitle1_Description3">

						</p>
					</div>
					<router-link to="/curriculum/guide">
						<div class="button">
							<span v-html="l10.All_Main_Body_Title3_Subtitle1_Button1"></span>

						</div>
					</router-link>
				</div>
				<div class="img">
					<template v-if='lang == "en"'>
						<img src="../../assets/home/img-main-features-setcion-1.png" srcset="../../assets/home/img-main-features-setcion-1@2x.png 2x,
				../../assets/home/img-main-features-setcion-1@3x.png 3x" class="img_main_features_setcion1">
					</template>
					<template v-else>
						<img :src='require(`@/assets/home/todomath_main_feature_mode_${lang}.png`)'>
					</template>
				</div>
			</div>
			<div class="descriptions">
				<div class="img">
					<template v-if='lang == "en"'>
						<img src="../../assets/home/img-main-features-setcion-2.png" srcset="../../assets/home/img-main-features-setcion-2@2x.png 2x,
				../../assets/home/img-main-features-setcion-2@3x.png 3x" class="img_main_features_setcion1">
					</template>
					<template v-else>
						<img :src='require(`@/assets/home/todomath_main_feature_free_${lang}.png`)'>
					</template>
				</div>
				<div class="description">
					<p class="title" v-html="l10.All_Main_Body_Title3_Subtitle2">

					</p>
					<div class="text">

						<p v-html="l10.All_Main_Body_Title3_Subtitle2_Description1">

						</p>

						<p v-html="l10.All_Main_Body_Title3_Subtitle2_Description2">

						</p>

						<p v-html="l10.All_Main_Body_Title3_Subtitle2_Description3">

						</p>
					</div>
					<router-link to="/features">
						<div class="button">
							<span v-html="l10.All_Main_Body_Title3_Subtitle2_Button1"></span>

						</div>
					</router-link>
				</div>

			</div>

		</div>

	</div>
	<div id="article3" class="container">
		<img src="../../assets/home/img-main-award.png" srcset="../../assets/home/img-main-award@2x.png 2x,
             ../../assets/home/img-main-award@3x.png 3x" />
		<p v-html="l10.All_Main_Body_Title4">

		</p>

	</div>
	<TryTodomathBottom @click-cn-androiddownload="handleClickAndroidDownload"></TryTodomathBottom>
	<div class="container">
		<Footer>

		</Footer>
	</div>
</div>
</template>
<script>
import Menubar from '../../components/menubar/LaptopLayout.vue'
import TryTodomathBottom from '../../components/footer/TryTodomathLaptop.vue'
import Footer from '@/components/footer/FooterLaptop.vue'

export default {
	name: 'HomeLaptopFrame',
	components: {
		Menubar,
		TryTodomathBottom,
		Footer
	},
	data() {
		const text = require('../../text/home/laptop.js').default;
		const l10n = text[this.$store.state.lang] ? text[this.$store.state.lang] : text['en'];
		return {
			lang: this.$store.state.lang,
			l10: l10n,
			appStoreUrl: this.$store.state.appStoreUrl,
			googlePlayUrl: this.$store.state.googlePlayUrl,
			cnDownloadUrl: this.$store.state.cnDownloadUrl,
		}
	},
	methods: {
		handleClickAndroidDownload() {
			this.$emit('click-cn-androiddownload')
		}
	}
}
</script>
<style  scoped>
.content {
	width: 100%;
	overflow: hidden;
}

.container {
	margin: 0 auto;
	height: auto;
	min-height: 100px;
	width: 1024px;
}

.position {
	position: relative;
}

.position .center {
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
}

.main-banner {
	background-image: url('../../assets/home/img-main-top-bg-84.png');
	background-repeat: no-repeat;
	background-position: center;
	height: 1108px;
	background-size: 1440px auto;
	padding-top: 196px;

}

.main-banner .container {
	position: relative;
}

.main-banner .title {
	font-size: 76px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.16;
	letter-spacing: -3px;
	text-align: center;
	color: #ffffff;
	width: 100%;


}

.main-banner .subtitle {
	font-size: 32px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.25;
	letter-spacing: -0.7px;
	text-align: center;
	color: #ffffff;
	width: 100%;
	margin-top: 13px;
}

.icon_video {
	width: 27px;
	height: 27px;
	object-fit: contain;
	float: left;

}

.main-banner .subject-video {

	font-size: 22px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;

	letter-spacing: -0.5px;
	color: #f8ff24;
	margin-top: 28px;
	width:
}

.main-banner .subject-video p {
	float: left;
	line-height: 27px;
	margin-left: 7px;
}

.main-banner .download {
	top: 604px;
	width: 100%;
	display: flex;
	flex-flow: row;
	justify-content: center;
	margin-top: 63px;

}

.main-banner .download .store-btn {
	width: 210px;
	height: 64px;
	border-radius: 8px;
	border: solid 3px #ffffff;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}

.main-banner .download .store-btn~.store-btn {
	margin-left: 20px;
}

.main-banner .animation {
	position: absolute;
	left: 770px;
	top: 530px;


}

.main-banner .animation>img {
	width: 367px;
	height: 226px;
}

#appstore {
	margin-top: -4px;
}

.article {
	width: 100%;
	position: relative;
}

#article1 {

	background-color: rgba(255, 0, 0, 0.0);
	height: 1212px;
	padding-top: 133px;
}

#article1 .title {
	font-size: 76px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.16;
	letter-spacing: -3px;
	text-align: center;
	color: #41403e;



}

#article1 .subtitle {
	font-size: 32px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.25;
	letter-spacing: -1.3px;
	text-align: center;
	color: #41403e;
	margin-top: 16px;

}

#article1 .articles {
	display: flex;
	flex-flow: row;
	justify-content: space-between;
	margin-top: 85px;
	width: 100%;
	padding: 0 15px;
}

#article1 .articles>div {
	width: 308px;
	display: flex;
	flex-direction: column;
}

#article1 .articles>div>img {
	max-width: 60px;
	align-self: center;
}

#article1 .articles>div>p.description {
	font-size: 18px;
	font-weight: normal;
	font-style: italic;
	font-stretch: normal;
	line-height: 1.56;
	letter-spacing: -0.8px;
	text-align: center;
	color: #808080;
	color: #808080;
	margin-top: 18px;
	width: 100%;
	flex-grow: 1;
}

#article1 .articles>div>p.source {
	font-size: 18px;
	font-weight: normal;
	font-style: italic;
	font-stretch: normal;
	line-height: 1.56;
	letter-spacing: -0.7px;
	text-align: center;
	color: #bebebe;
	align-self: flex-end;
	width: 100%;
}

#article1 #download600Img {

	width: 857px;
	height: 524px;
	background-image: url('../../assets/home/img-main-600-download.png');
	background-repeat: no-repeat;
	background-position: bottom;
	z-index: -100;
	background-size: contain;

	margin: 0 auto;

}


#article2 {
	position: relative;
	margin-top: -130px;
	background-image: url('../../assets/home/img-main-features-bg-90@2x.png');
	background-repeat: no-repeat;
	background-size: 1440px auto;
	background-position: center;
	padding-bottom: 200px;
	height: 2047px;
}

#article2>div>p:first-of-type {
	position: relative;
	padding-top: 206px;
	width: 100%;
	font-size: 76px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.16;
	letter-spacing: -3px;
	text-align: center;
	color: #ffffff;
}

#article2 .descriptions {
	display: flex;
	align-items: center;
	text-align: left;
	margin-right: -80px;
	color: #000;
}

#article2 .descriptions:first-of-type {
	margin-left: 10px;
	margin-top: 56.8px;
	margin-right: -180px;

}

#article2 .descriptions>* {
	float: left;
}

#article2 .descriptions:last-of-type {
	margin-left: -155px;
	margin-top: 141px;

}

#article2 .descriptions:first-of-type>.description {
	width: 411px;
}

#article2 .descriptions>.description .text {
	height: 250px;

}

#article2 .descriptions:first-of-type>.description .text p {
	width: 411px;

}

#article2 .descriptions>.description .text {
	margin-top: 36px;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}

#article2 .descriptions:last-of-type>.description {
	width: 421px;

	margin-left: 20px;
	align-self: flex-start;
}

#article2 .descriptions>.description .text p {
	padding-left: 20px;
	width: 100%;
}

#article2 .descriptions>.description .text p:nth-child(2) {
	align-self: center;
}

#article2 .descriptions>.description .text p:nth-child(3) {
	align-self: flex-end;
}

#article2 .descriptions>.description .text p::before {
	content: url("../../assets/home/icon-text-el-wh.svg");
	position: absolute;
	transform: scale(0.8) translateX(-25px) translateY(-3px);
}

#article2 .descriptions:first-of-type>.img {
	width: calc(961px * 0.84);
	height: calc(796px * 0.84);
	object-fit: contain;
	margin-left: -25px;
}

#article2 .descriptions:first-of-type>.img>img {
	width: 100%;
}

#article2 .descriptions .description:first-child>.description {
	width: 411px;
}

#article2 .descriptions:last-child>.img {
	width: calc(874px * 0.84);
	height: calc(742px * 0.84);
	object-fit: contain;
}

#article2 .descriptions:last-child>.img>img {
	width: 100%;
}

#article2 .descriptions .title {
	font-size: 42px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.29;
	letter-spacing: -1.8px;
	color: #ffffff;
}

#article2 .descriptions .text {
	font-size: 22px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.45;
	letter-spacing: -0.9px;
	color: #ffffff;
}

#arcicle2 .bulletedlist {
	width: 8px;
}

#article2 .descriptions .description .button {
	margin-top: 60px;
	width: 317px;
	height: 64px;
	border-radius: 36px;
	border: solid 3px #f8ff24;
	text-align: center;
	font-size: 22px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 59px;
	letter-spacing: -1px;
	text-align: center;
	color: #f8ff24;
	display: inline-block;
}

#article2 .descriptions .description .button::after {
	content: url('../../assets/home/img-btn-arrow.svg');
	position: relative;
	padding-left: 5px;
	display: inline-block;
	transform: scale(0.85);
	top: 3px;

}

#article3 {
	/* margin-top:-100px; */
	height: 1100px;
	position: relative;
}

#article3>img {
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	width: 1120px;
	height: auto;
	margin-top: 50px;
}

#article3>p {
	font-size: 76px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.16;
	letter-spacing: -3px;
	text-align: center;
	color: #41403e;
	position: relative;
	top: 116px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/HomeLaptop.vue